<template>
  <div class="content">
    <div class="container ad_main">
      <h3 class="mb10">{{ $route.query.id ? $t('common.editAdsense') : $t('common.addAdsense') }}</h3>
      <el-form :model="formData" ref="formRef" :rules="formRules" label-position="left" label-width="120px">
        <div>
          <!-- 添加广告位 -->
          <div class="form_pad">
              <el-form-item :label="$t('table.application')" prop="application_id">
                <el-select 
                  v-model="formData.application_id" 
                  filterable 
                  :placeholder="$t('common.selectApp')"
                  class="w400"
                  @change="appChange"
                >
                  <el-option
                    v-for="(item,index) in appList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item :label="$t('table.adsenseName')" prop="name">
                <el-input v-model="formData.name" class="w400" :placeholder="$t('required.adName')"></el-input>
              </el-form-item>
              <el-form-item :label="$t('table.coMode')" prop="co_mode">
                <el-select 
                  v-model="formData.co_mode" 
                  filterable 
                  :placeholder="$t('common.selectMode')"
                  class="w400"
                  @change="modeChange"
                  >
                    <el-option
                    v-for="(item,index) in $com.modeList"
                    :key="item.id"
                    :label="$i18n.locale == 'zh'?item.name : item.en_name"
                    :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item v-if="formData.co_mode == 1" :label="$t('table.zhpdPrice')" prop="min_price">
                <el-input v-model="formData.min_price" class="w400" @blur="formData.min_price=Number(formData.min_price)">
                </el-input>
                <span> {{formData.co_mode == 1 && formData.area == 2?  $t('common.meiyuan'): $t('common.yuan')}}/cpm</span>
              </el-form-item>
              <!-- <el-form-item :label="$t('table.coArea')" prop="area">
                <el-select 
                  v-model="formData.area" 
                  filterable 
                  :placeholder="$t('common.selectArea')"
                  class="w400"
                  @change="areaChange"
                  >
                    <el-option
                    v-for="(item,index) in $com.areaList"
                    :key="item.id"
                    :label="$i18n.locale == 'zh'?item.name : item.en_name"
                    :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item> -->
          </div>
        </div>
        <!-- 流量类型 -->
        <div>
          <h4 class="mtb">{{$t('sdk.flowType')}}</h4>
          <div class="flow">
            <el-card 
              class="flow_item" 
              :class="formData.flow_type == item.id? 'flow_item_active':''" 
              v-for="item in $com.flowTypeList"
              v-show="item.show"
              @click.native="flowTypeChange(item)"
            >
              <h4>{{$i18n.locale == 'zh'?item.name : item.en_name}}</h4>
              <p>{{$i18n.locale == 'zh'?item.introduce : item.in_en_name}}</p>
            </el-card>
          </div>
        </div>
        <!-- 广告模板 -->
        <div>
          <h4 class="mtb">{{$t('sdk.adTemplate')}}</h4>
          <div class="form_pad">
            <el-form-item label-width="0" prop="template_id">
              <el-checkbox-group v-model="formData.template_id">
                <el-checkbox 
                  v-for="item in templateList" 
                  :label="item.template_id" 
                  :key="item.template_id">
                  {{$i18n.locale == 'zh'?item.name : item.en_name}}-{{ item.template_id }}
                </el-checkbox>
              </el-checkbox-group>
            </el-form-item>
          </div>
        </div>
         <!-- 模板尺寸
         <div v-if="formData.area == 2">
          <h4 class="mtb">{{$t('sdk.templateSize')}}</h4>
          <div class="form_pad">
            <el-form-item label-width="0" prop="size_ids">
              <el-checkbox-group v-model="formData.size_ids">
                <el-checkbox 
                  v-for="item in sizeList" 
                  :label="item.size_id" 
                  :key="item.size_id">
                  {{$i18n.locale == 'zh'?item.name : item.en_name}}-{{ item.size_id }}
                </el-checkbox>
              </el-checkbox-group>
            </el-form-item>
          </div>
        </div> -->
      </el-form>
      <!-- 样式配置 -->
      <div v-if="[1,2,3,4,7, 11].indexOf(formData.flow_type) !== -1 && dockingValue == 1">
        <h4 class="mtb">{{$t('sdk.styleConfig')}}</h4>
        <el-form :model="styleData" class="form_pad" :rules="styleRules" ref="styleRef" label-position="left" label-width="120px">
          <el-form-item :label="$t('sdk.rendeMode')">
            <el-radio-group v-model="styleData.rendering_type" @change="renderChange">
              <el-radio-button :label="1" v-if="formData.flow_type != 11">{{$t('sdk.platformRender')}}</el-radio-button>
              <!-- 仅sdk且信息流展示自渲染 -->
              <!-- native且sdk仅展示自渲染 -->
              <el-radio-button :label="2" v-if="formData.flow_type == 2 || formData.flow_type == 11">{{$t('sdk.selfRender')}}</el-radio-button>
            </el-radio-group>
          </el-form-item>
          <!-- 平台渲染 -->
          <el-form-item :label="$t('sdk.styleSelection')" v-if="styleData.rendering_type == 1 && (formData.flow_type == 2 || formData.flow_type == 11)" prop="style">
            <el-checkbox-group v-model="styleData.style">
              <el-checkbox 
                v-for="style in $com.styleList" 
                :label="style.id" 
                :key="style.id">
                {{$i18n.locale == 'zh' ? style.name : style.en_name}}
              </el-checkbox>
            </el-checkbox-group>
          </el-form-item>
          <!-- 自渲染 -->
          <!-- <el-form-item :label="$t('sdk.elConfig')" v-if="styleData.rendering_type == 2" prop="elements">
            <el-checkbox-group v-model="styleData.elements">
              <el-checkbox
                v-for="item in $com.elementsList"
                :key="item.label"
                :label="item.label"
                v-show="(item.showType === 0 || formData.flow_type === item.showType) && !(item.label === 'product' && formData.flow_type === 11)"
              >
                {{$i18n.locale == 'zh' ? item.name : item.en_name}}
              </el-checkbox>
            </el-checkbox-group>
          </el-form-item> -->
          <el-form-item :label="$t('sdk.videoSound')" v-if="formData.flow_type == 7">
            <el-radio-group v-model="styleData.video_sound">
              <el-radio-button :label="0">{{$t('sdk.soundOff')}}</el-radio-button>
              <el-radio-button :label="1">{{$t('sdk.soundRelease')}}</el-radio-button>
            </el-radio-group>
          </el-form-item>
          <el-form-item :label="$t('sdk.videoAutoplay')" v-if="formData.flow_type == 7">
            <el-radio-group v-model="styleData.video_auto_play">
              <el-radio-button :label="0">{{$t('sdk.videoNoAuto')}}</el-radio-button>
              <el-radio-button :label="1">{{$t('sdk.webcast')}}</el-radio-button>
              <el-radio-button :label="2">{{$t('sdk.wifiAuto')}}</el-radio-button>
            </el-radio-group>
          </el-form-item>
          <el-form-item :label="$t('sdk.callback')" v-if="formData.flow_type == 7">
            <el-radio-group v-model="callbackControl" @change="callbackChange">
              <el-radio-button :label="1">{{$t('sdk.noServer')}}</el-radio-button>
              <el-radio-button :label="2">{{$t('sdk.needServer')}}</el-radio-button>
            </el-radio-group>
          </el-form-item>
          <div v-if="callbackControl == 2">
            <el-form-item :label="$t('sdk.callbackUrl')" prop="callback_url">
              <el-input v-model.trim="styleData.callback_url" class="w400"></el-input>
            </el-form-item>
            <el-form-item :label="$t('sdk.secretKey')" prop="callback_key">
              <el-input v-model.trim="styleData.callback_key" class="w400">
                <el-button slot="append" @click="callbackKey">{{$t('sdk.newSecretKey')}}</el-button>
              </el-input>
            </el-form-item>
          </div>
        </el-form>
      </div>
      <!-- 能力配置，只国内 -->
      <div v-if="formData.area == 1">
        <h4 class="mtb">{{ $t('common.featureConfig') }}</h4>
        <el-form :model="abilityData" class="form_pad" label-position="left" label-width="120px">
          <el-form-item :label="$t('common.miniProgram')">
            <el-radio-group v-model="abilityData.is_miniprogram">
              <el-radio-button v-for="item in $com.yesOrNo" :key="item.id" :label="item.id">{{ $i18n.locale == 'zh'?item.name : item.en_name }}</el-radio-button>
            </el-radio-group>
          </el-form-item>
          <el-form-item :label="$t('common.quickApp')">
            <el-radio-group v-model="abilityData.is_fast_app">
              <el-radio-button v-for="item in $com.yesOrNo" :key="item.id" :label="item.id">{{ $i18n.locale == 'zh'?item.name : item.en_name }}</el-radio-button>
            </el-radio-group>
          </el-form-item>
          <el-form-item :label="$t('common.appWakeup')">
            <el-radio-group v-model="abilityData.is_deeplink">
              <el-radio-button v-for="item in $com.yesOrNo" :key="item.id" :label="item.id">{{ $i18n.locale == 'zh'?item.name : item.en_name }}</el-radio-button>
            </el-radio-group>
          </el-form-item>
          <el-form-item :label="$t('common.APKDownload')">
            <el-radio-group v-model="abilityData.is_download_apk">
              <el-radio-button v-for="item in $com.yesOrNo" :key="item.id" :label="item.id">{{ $i18n.locale == 'zh'?item.name : item.en_name }}</el-radio-button>
            </el-radio-group>
          </el-form-item>
          <el-form-item :label="$t('common.engagementMaterial')">
            <el-radio-group v-model="abilityData.is_induce_material">
              <el-radio-button v-for="item in $com.yesOrNo" :key="item.id" :label="item.id">{{ $i18n.locale == 'zh'?item.name : item.en_name }}</el-radio-button>
            </el-radio-group>
          </el-form-item>
        </el-form>
      </div>
      <div class="footer">
        <el-button type="primary" @click="onSave" :disabled="isDisabled">{{$t('save')}}</el-button>
        <el-button @click="handleCancel">{{$t('cancel')}}</el-button>
      </div>
    </div>
    <!-- 右侧广告位样式展示 -->
    <div class="container flow_style">
      <h3 class="mgb20">{{$t('sdk.adsenseShow')}}-{{ adName }}</h3>
      <el-tabs v-model="activeName">
        <el-tab-pane 
        v-for="item in styleList" 
          :label="$i18n.locale == 'zh'?item.name : item.en_name" 
          :name="item.id">
          <div class="style_item">
            <el-image
              style="width: 350px; height: 630px"
              :src="getImgSrc(item.img)"
              fit="contain"
            ></el-image>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>
<script>
const styleDataDefault = {
  rendering_type: 1,
  style: [],
  elements: [],
  video_sound: 0,
  video_auto_play: 0,
  callback_url: "",
  callback_key: "",
}
const abilityDataDefault = {
  is_miniprogram: 1,
  is_fast_app: 1,
  is_deeplink: 1,
  is_download_apk: 1,
  is_induce_material: 1
}
export default {
  data() {
    return {
      formData: {
        id: 0,
        application_id: null,
        name: "",
        co_mode: null,
        area: 1,
        min_price: null,
        name: "",
        flow_type: 1,
        template_id: [],
        size_ids: [],
      },
      isDisabled: false, // 防止重复点击
      timer: null,
      dockingValue: 1, //1:sdk, 2:api
      styleData: Object.assign({}, styleDataDefault),
      abilityData: Object.assign({}, abilityDataDefault),
      callbackControl: 1,
      appList: [],
      templateList: [],
      sizeList: [],
      styleList: [],
      activeName: "1",
      adName: "",
      formRules: {
        application_id: [
          { required: true, message: this.$t('common.selectApp'), trigger: "change"},
        ],
        name: [
          { required: true, message: this.$t('required.adName'), trigger: "blur"},
        ],
        co_mode: [
          { required: true, message: this.$t('common.selectMode'), trigger: "change"},
        ],
        area: [
          { required: true, message: this.$t('common.selectArea'), trigger: "change"},
        ],
        template_id: [
          { required: true, message: this.$t('required.template'), trigger: "change"},
        ],
        // size_ids: [
        //   { required: true, message: this.$t('required.templateSize'), trigger: "change"},
        // ],
        min_price: [
          { required: true, message: this.$t('required.zhpdPrice'), trigger: "blur"},
        ],
      },
      styleRules: {
        style: [
          { required: true, message: this.$t('required.style'), trigger: "change"},
        ],
        elements: [
          { required: true, message: this.$t('required.config'), trigger: "change"},
        ],
        callback_url: [
          { required: true, message: this.$t('required.callbackUrl'), trigger: "blur"},
        ],
        callback_key: [
          { required: true, message: this.$t('required.secretKey'), trigger: "blur"},
        ],
      }
    }
  },
  // watch: {
    // "formData.flow_type": function(val) {
    // 切换流量类型，如果合作地区是海外，那么默认选中流量类型对应的所有模板，并展示对应的模板尺寸供选择
    // if(this.formData.area == 2) {
    //   this.formData.template_id = []
    //   this.$com.flowTypeList.forEach(flow => {
    //     if(flow.id == this.formData.flow_type) {
    //       flow.template.forEach(item => {
    //         this.formData.template_id.push(item.template_id)
    //       })
    //     }
    //   })

    // }
    // }
  // },
  created() {
    if(this.$route.query.id) {
      this.getAdDetail()
    } else {
      this.flowTypeChange(this.$com.flowTypeList[0])
      this.areaChange(1)
    }
  },
  mounted() {
    this.getAPPList()
  },
  beforeDestroy() {
    if(this.timer) {
      clearTimeout(this.timer)
      this.timer = null
    }
  },
  methods: {
    getAPPList() {
      let params = {
        page: 1,
        page_size: 1000,
        // status: 1,
      };
      this.__postData('sspAppList', params, (res) => {
        if(res.list){
          this.appList = res.list
          this.appChange(this.formData.application_id)
        }
      })
    },
    appChange(val) {
      this.appList.forEach(item => {
        if(val == item.id) {
          this.dockingValue = item.docking_type
          this.flowTypeShow(this.dockingValue)
          // 如果选择了api类型应用时，重置样式配置
          if(item.docking_type == 2) {
            // 重置样式配置
            this.styleData = Object.assign({}, styleDataDefault)
          }
        }
      })
    },
    // 地区选择
    areaChange(val) {
      if(val == 1) { //国内
        this.formData.flow_type = 2
        this.flowTypeChange(this.$com.flowTypeList[0])
      } else { // 海外
        this.formData.flow_type = 1
        this.flowTypeChange(this.$com.flowTypeList[1])
      }
      this.abilityData =  Object.assign({}, abilityDataDefault)
      this.flowTypeShow(this.dockingValue)
    },
    // 流量类型控制显隐
    flowTypeShow(item) {
      this.$com.flowTypeList.forEach(flow => {
        // 判断是国内还是海外，国内的就正常走，海外的只展示激励视频和banner、native，国内不展示native
        if(this.formData.area == 1) {// 国内
          // sdk应用时 不展示角标、暂停、焦点图、图标、ott
          if(item == 1 && [5,6,8,9,10,11].indexOf(flow.id) !== -1) {
            flow.show = false
          } else {
            if([11].indexOf(flow.id) !== -1) {
              flow.show = false
            } else {
              flow.show = true
            }
          }
        } else {
          if([4,7,11, 1, 3].indexOf(flow.id) !== -1) {
            flow.show = true
          } else {
            flow.show = false
          }
        }
      })
    },
    getImgSrc(img) {
        return require('@/assets/img/flow_style/' + img)
    },
    // 切换渲染方式
    renderChange() {
      this.styleData.style = []
      this.styleData.elements = []
    },
    // 获取广告详情
    getAdDetail() {
      let params = {id: this.$route.query.id}
      this.__getData('getAdDetail', params, (res) => {
        for(var key in res) {
					if(key in this.formData) {
						this.formData[key] =	JSON.parse(JSON.stringify(res[key]))
					}
					if(key in this.styleData) {
						this.styleData[key] =	JSON.parse(JSON.stringify(res[key]))
					}
					if(key in this.abilityData) {
						this.abilityData[key] =	JSON.parse(JSON.stringify(res[key]))
					}
				}
        if(this.styleData.callback_key && this.styleData.callback_url) {
          this.callbackControl = 2
        }
        // 展示对应的流量类型
        let flow_type = (this.$com.flowTypeList.find(item => item.id == this.formData.flow_type))
        this.updateFlowData(flow_type)
      })
    },
    // 初始化或者更改流量类型重置模版和广告位展示
    updateFlowData(item) {
      this.formData.flow_type = item.id;
      this.templateList = this.formData.area == 1 ? item.template : item.abroad_template;
      this.adName = this.$i18n.locale == 'zh' ? item.name : item.en_name;
      this.styleList = item.style && item.style.length > 0 ? item.style : [];
      this.activeName = this.styleList.length > 0 ? this.styleList[0].id : '';
    },
    flowTypeChange(item) {
      this.updateFlowData(item);
      this.formData.template_id = [];
      this.formData.size_ids = [];
      this.sizeList = item.size;
      this.callbackControl = 1;
      this.styleData = Object.assign({}, styleDataDefault);
      this.styleData.rendering_type = item.id == 11 ? 2 : 1;
    },
    // 切换合作模式，清空pd价格
    modeChange(val) {
      if(val !== 1) {
        this.formData.min_price = null
      }
    },
    // 切换回调控制
    callbackChange() {
      this.styleData.callback_url = ""
      this.styleData.callback_key = ""
    },
    callbackKey() {
      this.styleData.callback_key = Array.from(window.crypto.getRandomValues(new Uint8Array(16))).map(b => ('00' + b.toString(16)).slice(-2)).join('');
    },
    onSave() {
      this.isDisabled = true
      this.timer = setTimeout(() => {
        this.isDisabled = false
        clearTimeout(this.timer)
      }, 1500);
      let that = this
      function validateForm1() {
        return new Promise((resolve, reject) => {
          // 表单校验逻辑...
          that.$refs["formRef"].validate((valid) => {
            if(valid) {
              resolve();
            } else {
              reject();
            }
          })
        });
      }
      function validateForm2() {
        return new Promise((resolve, reject) => {
          // 表单校验逻辑...
          if ([1,2,3,4,7].indexOf(that.formData.flow_type) !== -1 && that.dockingValue == 1) {
            that.$refs["styleRef"].validate((valid) => {
                if (valid) {
                    resolve();
                } else {
                    reject();
                }
            });
          } else {
            // 不需要校验直接resolve
            resolve();
          }
        });
      }
      // 首先执行第一个表单校验
      validateForm1()
        // 如果第一个表单校验通过，那么执行第二个表单校验
        .then(validateForm2)
        .then(() => {
          console.log('所有表单都通过校验，并且数据已经保存')
          let params = Object.assign({}, this.formData, this.styleData, this.abilityData);
          this.__postData('adAddOrUpdate', params, (res) => {
            clearTimeout(this.timer)
            this.timer = null
            if(res.code == 1) {
              this.$message.error(res.msg);
            } else {
              this.$message.success(this.$t('message.successSava'));
              this.handleCancel()
            }
            this.isDisabled = false
          })
        })
        .catch((err) => {
          this.isDisabled = false;
          clearTimeout(this.timer);
          this.timer = null;
          this.$message.error(this.$t('message.errorComplete'));
          console.log('有表单未通过校验，保存操作被终止', err)
        });

      // this.$refs["styleRef"].validate((valid) => {
      //   if(valid) {
      //     let params = Object.assign({}, this.formData, this.styleData);
      //     this.__postData('adAddOrUpdate', params, (res) => {
      //       if(res.code == 1) {
      //         this.$message.error(res.msg);
      //       } else {
      //         this.$message.success("保存成功");
      //         this.handleCancel()
      //       }
      //     })
      //   } else {
      //     this.$message.error("请填写必要信息");
      //   }
      // })
    },
    handleCancel() {
      this.$router.back()
    }
  }
}
</script>
<style lang="scss" scoped>
.content {
  height: auto;
  display: flex;
  justify-content: flex-start;
  .ad_main {
    flex: 1;
  }
  .flow_style {
    margin-left: 10px;
    width: 350px;
    .style_item {
      width: 100%;
      text-align: center;
      margin-top: 10px;
    }
  }
}
/deep/.el-tabs {
  .el-tabs__nav {
    width: 100%;
    text-align: center;
    overflow-x: scroll;
    &::-webkit-scrollbar {
      height: 3px;
    }
  }
  .el-tabs__item.is-active, .el-tabs__item:hover {
    color: #3361FF;
  }
  .el-tabs__active-bar {
    background-color: transparent;
  }
}
.form_pad {
  padding: 0 30px;
}
.w400 {
  width: 400px;
}
.mtb {
  margin: 20px 0 10px 0;
}
.flow {
  display: flex;
  flex-wrap: wrap;
  .flow_item {
    width: 32%;
    padding: 0;
    margin: 0;
    margin-bottom: 10px;
    margin-right: 5px;
    cursor: pointer;
    p {
      font-size: 12px;
    }
  }
}
.flow_item_active {
  border: 1px solid #3361FF;
  color: #3361FF;
}
.footer {
  display: flex;
  justify-content: center;
  padding-top: 20px;
}


</style>